import styled from 'styled-components';

export const TimelineWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  max-width: 700px;
`;

export const TimelineStep = styled.div`
  display: flex;
  gap: 1.5rem;
  position: relative;
  padding-bottom: 3rem;

  &:last-child {
    padding-bottom: 0;
  }

  &:not(:last-child)::before {
    content: '';
    position: absolute;
    left: 23px;
    top: 48px;
    bottom: 0;
    width: 2px;
    background: #d1d5db;
  }
`;

export const TimelineNumber = styled.div`
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #000000;
  color: #d1ff94;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 1.1rem;
  z-index: 1;
`;

export const TimelineContent = styled.div`
  padding-top: 0.5rem;
`;

export const TimelineTitle = styled.h3`
  font-size: 1.3rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 0.5rem;
`;

export const TimelineText = styled.p`
  color: #6b7280;
  font-size: 1rem;
  line-height: 1.7;
`;
